// import Cookies from 'js-cookie'

const app = {
  state: {
    commonality: {}, // 公共参数
    portAbnormal: '', // 接口异常状态
    term: '', // 学年学期头部公共组件部分
    recordCount: 5 // 获取学年学期记录条数
  },
  mutations: {
    set_portAbnormal: (state, stus) => {
      state.sidebar = stus
    },
    set_commonality: (state, stus) => {
      if (JSON.stringify(stus) === '{}') {
        state.commonality = ''
      } else {
        if (state.commonality) {
          // 清除空对象
          for (let name in state.commonality) {
            if (!state.commonality[name] && state.commonality[name] !== 0) {
              delete state.commonality[name]
            }
          }
        }
        // 数组对象去重 2
        // var arr = [
        // { a: 'o1', c: 'a' },
        // { a: 'e2', c: 'b' },
        // ]
        // var array = arr.reduce((init, current) => {
        // let index = init.findIndex(r => r.a === current.a)
        // if (index >= 0) {
        //   init.splice(index, 1)
        // }
        // init.push(current)
        // return init
        // }, [])
        state.commonality = Object.assign({}, state.commonality || {}, stus)
        // }
      }
    },
    set_term: (state, stus) => {
      if (JSON.stringify(stus) === '{}') {
        state.term = ''
      } else {
        if (state.term) {
          // 清除空对象
          for (let name in state.term) {
            if (!state.term[name] && state.term[name] !== 0) {
              delete state.term[name]
            }
          }
        }
        state.term = Object.assign({}, state.term || {}, stus)
      }
    }
  },
  actions: {
    set_portAbnormal: ({
      commit
    }, val) => {
      commit('set_portAbnormal', val)
    },
    set_commonality: ({
      commit
    }, val) => {
      sessionStorage.setItem(
        'commonality',
        JSON.stringify(
          Object.assign(
            JSON.parse(sessionStorage.getItem('commonality') || '{}'),
            val
          )
        )
      )
      commit('set_commonality', val)
    },
    set_term: ({
      commit
    }, val) => {
      sessionStorage.setItem(
        'term',
        JSON.stringify(
          Object.assign(
            JSON.parse(sessionStorage.getItem('term') || '{}'),
            val
          )
        )
      )
      commit('set_term', val)
    }
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/aside.js